import { BottomDrawerModal } from "@/components/shared/bottom-drawer-modal";
import { ListHeading } from "@/components/shared/list-header";
import type {
  DurationOption,
  FrequencyOption,
} from "@/components/shared/service-radio-item/types";
import { Button, View, RadioGroup } from "@/components/ui";
import { Clock } from "@/components/shared/icons";
import { ServiceRadioItem } from "@/components/shared/service-radio-item";
import { Typography } from "@/components/shared/typography";
import { useMemo } from "react";
import { PackageFrequencyGroupEnum } from "@/types/booking";
import { ServiceDurationOptions } from "@/constants/booking";

export function CleaningDurationModal({
  open,
  selectedDurationOptionValue,
  onProceed,
  setOpen,
  selectedFrequencyOption,
  onSelectDurationOption,
  loading,
}: {
  open: boolean;
  loading: boolean;
  selectedDurationOptionValue: string;
  selectedFrequencyOption: FrequencyOption;
  onProceed(): void;
  setOpen: (open: boolean) => void;
  onSelectDurationOption(item: DurationOption): void;
}) {
  const durationSubTitle = useMemo(() => {
    switch (selectedFrequencyOption.frequency) {
      case PackageFrequencyGroupEnum.WEEKLY:
      case PackageFrequencyGroupEnum.FORTNIGHT:
        return ["$18/hr - $20/hr", "$18/hr - $22/hr"];
      case PackageFrequencyGroupEnum.AD_HOC:
        return ["$23/hr - $25/hr", "$23/hr - $25/hr"];
      case PackageFrequencyGroupEnum.NEXT_DAY_AD_HOC:
        return ["$16/hr", "$16/hr"];
      default:
        return ["", ""];
    }
  }, [selectedFrequencyOption.frequency]);
  return (
    <BottomDrawerModal scroll open={open} onOpenChange={setOpen}>
      <View className="flex flex-col gap-4 overflow-hidden">
        <ListHeading title="Cleaning Duration" icon={Clock} subtitle="" />
        <Typography variant="body-sm" color="foreground-intermediate">
          We recommend at least 3 hrs for up to 2 bedrooms, and 4 hrs and up for
          larger apartments. You can always change this again. (Min 3 hours)
        </Typography>
        <RadioGroup
          value={selectedDurationOptionValue}
          onValueChange={(value) => {
            onSelectDurationOption(
              ServiceDurationOptions.find(
                (opt) => opt.value === value,
              ) as DurationOption,
            );
          }}
        >
          {ServiceDurationOptions.map((item, index) => {
            return (
              <ServiceRadioItem
                key={item.value}
                title={`${item.duration} Hours`}
                subTitle={durationSubTitle[index]}
                selected={item.value === selectedDurationOptionValue}
                slogan={item.slogan || ""}
                value={String(item.value)}
                onSelect={() => onSelectDurationOption(item)}
              />
            );
          })}
        </RadioGroup>

        <Button
          variant="primary"
          color="CTA"
          iconAlignment="end"
          iconName="arrowRight"
          onClick={onProceed}
          loading={loading}
          children="Proceed"
        />
      </View>
    </BottomDrawerModal>
  );
}
